/**
 * Channel Badge Component
 * Displays channel type with icon
 */

import type { ChannelType } from '../types'

interface ChannelBadgeProps {
  channel: ChannelType | string | null
  size?: 'sm' | 'md'
}

const channelConfig: Record<string, { icon: string; bg: string; text: string; label: string }> = {
  EMAIL: {
    icon: '✉️',
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    label: 'Email',
  },
  SMS: {
    icon: '💬',
    bg: 'bg-green-50',
    text: 'text-green-700',
    label: 'SMS',
  },
  WHATSAPP: {
    icon: '📱',
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    label: 'WhatsApp',
  },
  PUSH: {
    icon: '🔔',
    bg: 'bg-purple-50',
    text: 'text-purple-700',
    label: 'Push',
  },
  MOBILE_PUSH: {
    icon: '📲',
    bg: 'bg-purple-50',
    text: 'text-purple-700',
    label: 'Mobile Push',
  },
  WEB_PUSH: {
    icon: '🌐',
    bg: 'bg-indigo-50',
    text: 'text-indigo-700',
    label: 'Web Push',
  },
  RCS: {
    icon: '💎',
    bg: 'bg-cyan-50',
    text: 'text-cyan-700',
    label: 'RCS',
  },
}

const sizeClasses = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-1',
}

export function ChannelBadge({ channel, size = 'md' }: ChannelBadgeProps) {
  const config = channelConfig[channel || ''] || {
    icon: '📨',
    bg: 'bg-gray-50',
    text: 'text-gray-700',
    label: channel,
  }

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md font-medium ${config.bg} ${config.text} ${sizeClasses[size]}`}
    >
      <span>{config.icon}</span>
      {config.label}
    </span>
  )
}

export default ChannelBadge
